import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Async from 'react-select/async';
import { default as defaultComponents, styles } from './Components';
import AsyncCreatableSelect from 'react-select/async-creatable';

var isGroup = function isGroup(optionsOrGroups) {
  return optionsOrGroups.length > 0 && optionsOrGroups[0].options;
};

var filterTextInOptions = function filterTextInOptions(inputValue, options) {
  return options.filter(function (i) {
    return i.label.toLowerCase().includes(inputValue.toLowerCase());
  });
};

var filterText = function filterText(inputValue, optionsOrGroups) {
  if (isGroup(optionsOrGroups)) {
    return optionsOrGroups.map(function (g) {
      return _objectSpread({}, g, {
        options: filterTextInOptions(inputValue, g.options)
      });
    }).filter(function (g) {
      return !!g.options.length;
    });
  } else {
    return filterTextInOptions(inputValue, optionsOrGroups);
  }
};

var isPrimitiveValue = function isPrimitiveValue(val) {
  return typeof val === 'string' || typeof val === 'number' || typeof val === 'boolean';
};

var flattenGroups = function flattenGroups(groupedOptions) {
  if (groupedOptions) {
    if (isGroup(groupedOptions)) {
      return groupedOptions.reduce(function (prev, group) {
        return prev.concat(group.options);
      }, []);
    } else {
      return groupedOptions;
    }
  }

  return [];
};
/**
 * @extends {React.Component<import('./types').FormInputMultiSelectProps & import('@material-ui/core').WithStyles<typeof styles, true>> }
 */


var MultiSelect =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MultiSelect, _React$Component);

  function MultiSelect() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MultiSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MultiSelect)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.optionsCache = {};
    _this.innerRef = React.createRef();

    _this.onLoad = function (inputValue) {
      if (_this.props.onLoad) {
        return _this.props.onLoad(inputValue).then(function (options) {
          flattenGroups(options).map(function (option) {
            return _this.optionsCache[option.value] = option;
          });
          return options;
        }).then(function (options) {
          var filteredOptions = _this.props.filterAfterLoad ? filterText(inputValue, options) : options;
          return filteredOptions;
        }).then(_this.loadInitialValues);
      } else if (_this.props.options) {
        flattenGroups(_this.props.options).map(function (option) {
          return _this.optionsCache[option.value] = option;
        });
        var filteredOptions = filterText(inputValue, _this.props.options);
        return Promise.resolve(filteredOptions);
      }

      throw 'Invalid options';
    };

    _this.loadingInitialValues = false;
    _this.missingIdsFromCache = [];

    _this.loadInitialValues = function (options) {
      if (!_this.props.onInitialLoad) return options;
      if (_this.loadingInitialValues) return options;

      var missingIds = _this.getMissingValues();

      missingIds = missingIds.filter(function (id) {
        return _this.missingIdsFromCache.indexOf(id) === -1;
      });
      if (!missingIds.length) return options;
      _this.loadingInitialValues = true;
      return _this.props.onInitialLoad(missingIds).then(function (initialOptions) {
        flattenGroups(initialOptions).map(function (option) {
          return _this.optionsCache[option.value] = option;
        });
        return initialOptions;
      });
    };

    _this.getMissingValues = function () {
      var _this$props = _this.props,
          value = _this$props.value,
          defaultValue = _this$props.defaultValue,
          multi = _this$props.multi;
      var valToCheck = _this.isControlled() ? value : defaultValue;
      /**@type {import('./types').SelectValueType[]} */

      var valuesToCheck = [];
      if (!valToCheck) return valuesToCheck; // @ts-ignore

      if (!multi) valuesToCheck = [valToCheck]; // @ts-ignore
      else valuesToCheck = valToCheck;
      valuesToCheck = valuesToCheck.filter(function (val) {
        return !_this.optionsCache[val];
      });
      return valuesToCheck;
    };

    _this.isControlled = function () {
      return typeof _this.props.value !== 'undefined';
    };

    _this.getValueType = function () {
      var _this$props2 = _this.props,
          value = _this$props2.value,
          defaultValue = _this$props2.defaultValue,
          multi = _this$props2.multi;
      var valToCheck = _this.isControlled() ? value : defaultValue;

      if (multi) {
        if (!valToCheck) valToCheck = [];
        if (Array.isArray(valToCheck) && valToCheck.length === 0) //default to value
          return 'value';
        if (isPrimitiveValue(valToCheck[0])) return 'value';
        return 'object';
      } else {
        if (isPrimitiveValue(valToCheck)) return 'value';
        return 'object';
      }
    };

    _this.getLabelForValue = function (value) {
      if (_this.optionsCache) {
        var option = _this.optionsCache[value];
        if (!option) return ''; //no label

        return option.label;
      }

      return '';
    };

    _this.getOptionLabel = function (_ref) {
      var value = _ref.value;
      return _this.getLabelForValue(value);
    };

    _this.getReactSelectValue = function (value) {
      if (typeof value === 'undefined') return undefined;
      var valueToReturn = value;

      if (_this.getValueType() === 'value') {
        if (_this.props.multi) {
          if (!value) return [];
          valueToReturn = value.map(function (v) {
            return _objectSpread({}, _this.optionsCache[v], {
              value: v,
              label: _this.getLabelForValue(v)
            });
          });
        } else {
          valueToReturn = _objectSpread({}, _this.optionsCache[value], {
            value: value,
            label: _this.getLabelForValue(value)
          });
        }
      }

      return valueToReturn;
    };

    _this.getValue = function () {
      return _this.getReactSelectValue(_this.props.value);
    };

    _this.getDefaultValue = function () {
      return _this.getReactSelectValue(_this.props.defaultValue);
    };

    _this.focus = function () {
      return _this.innerRef.current && _this.innerRef.current.focus();
    };

    _this.blur = function () {
      return _this.innerRef.current && _this.innerRef.current.blur();
    };

    _this.onChange = function (option, e) {
      var multi = _this.props.multi;
      var value = option ? multi ? option.map(function (v) {
        return v.value;
      }) : option.value : null;
      return _this.props.onChange(value, option, e);
    };

    _this.render = function () {
      var _this$props3 = _this.props,
          classes = _this$props3.classes,
          theme = _this$props3.theme,
          searchable = _this$props3.searchable,
          clearable = _this$props3.clearable,
          multi = _this$props3.multi,
          disabled = _this$props3.disabled,
          onLoad = _this$props3.onLoad,
          defaultValue = _this$props3.defaultValue,
          value = _this$props3.value,
          onChange = _this$props3.onChange,
          components = _this$props3.components,
          creatable = _this$props3.creatable,
          customSelectStyles = _this$props3.customSelectStyles,
          rest = _objectWithoutProperties(_this$props3, ["classes", "theme", "searchable", "clearable", "multi", "disabled", "onLoad", "defaultValue", "value", "onChange", "components", "creatable", "customSelectStyles"]);

      var selectStyles = _objectSpread({
        groupHeading: function groupHeading(base) {
          return _objectSpread({}, base, {
            textTransform: 'inherit'
          });
        },
        menuPortal: function menuPortal(base, state) {
          return _objectSpread({}, base, {
            opacity: state.isDisabled ? '.5' : '1',
            zIndex: 9999
          });
        },
        input: function input(base) {
          return _objectSpread({}, base, {
            color: theme.palette.text.primary,
            '& input': {
              font: 'inherit'
            },
            height: '30px',
            zIndex: 9999
          });
        },
        valueContainer: function valueContainer(base) {
          var CURSOR_TYPE = 'text';
          if (!searchable) CURSOR_TYPE = 'pointer';
          return _objectSpread({}, base, {
            minHeight: '38px',
            cursor: CURSOR_TYPE
          });
        },
        indicatorsContainer: function indicatorsContainer(base) {
          return _objectSpread({}, base, {
            cursor: 'pointer'
          });
        }
      }, customSelectStyles);

      var AsyncComponent = creatable ? AsyncCreatableSelect : Async;
      return React.createElement(AsyncComponent, Object.assign({
        classes: classes,
        components: _objectSpread({}, defaultComponents, components),
        ref: _this.innerRef,
        noOptionsMessage: function noOptionsMessage() {
          return 'No results found';
        },
        loadOptions: _this.onLoad,
        defaultOptions: true,
        cacheOptions: true,
        styles: selectStyles,
        value: _this.getValue(),
        defaultValue: _this.getDefaultValue(),
        onChange: _this.onChange,
        isDisabled: disabled,
        isSearchable: searchable,
        isMulti: multi,
        menuPortalTarget: document.body,
        menuPosition: "fixed",
        isClearable: clearable,
        getOptionLabel: !creatable ? _this.getOptionLabel : undefined
      }, rest));
    };

    return _this;
  }

  return MultiSelect;
}(React.Component);
/**@type {Partial<import('./types').FormInputMultiSelectProps>} */


MultiSelect.defaultProps = {
  options: [],
  filterAfterLoad: true,
  defaultValue: null,
  multi: false,
  creatable: false,
  components: {}
};
export default withStyles(styles, {
  withTheme: true,
  name: 'ECMultiSelect'
})(MultiSelect);